export function generatePageTitle(specificName) {
    const baseTitle = import.meta.env.VITE_APP_BASE_TITLE || 'Latin Map';
    if (specificName && specificName.trim() !== '') {
        return `${specificName} | ${baseTitle}`;
    }
    return baseTitle;
}